import React, { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";
import { useForm } from "../../../../../../Base/Hooks/useForm";
import { getEstadosCategory } from "../../../../../../API/Global/Status/StatusRequests";
import { getAreasAct } from "../../../../../../Base/API/Global/Areas/AreasRequests";
import {
  editarRedVideo,
  getClaseRed,
  getMarcas,
  getRedes,
  getTipoDispositivos,
  getTipoRed,
  guardarRedVideo,
} from "../../../../../../API/IT/Dispositivos/DispositivosRequest";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import AutoCompleteDropdown from "../../../../../../Base/Components/Form/AutoCompleteDropdown";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import Loader from "../../../../../../Base/Components/Loader/Loader";
import { Toast } from "primereact/toast";
import { toastShow } from "../../../../../../Base/Services/ToastService";
import { getActivosFijos } from "../../../../../../API/Global/ActivosFijos/ActivosFijosRequest";

const RedVideoCRUD = ({ listRedVideo, showDialog, redVideo, setShowDialog, getInfo }) => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);

  const [loading, setLoading] = useState(false);
  const [estados, setEstados] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [areas, setAreas] = useState([]);
  const [tipoDispositivos, setTipoDispositivos] = useState([]);
  const [activos, setActivos] = useState([]);
  const [redes, setRedes] = useState([]);

  const initialValues = {
    IdRedVideo: -1,
    IdEstado: redVideo ? redVideo?.IdEstado : 5,
    IdTipoDispositivo: null
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } =
    useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);

    const marcasTempo = await getMarcas();
    setMarcas(marcasTempo);

    const areasTempo = await getAreasAct();
    setAreas(areasTempo);

    const activosTempo = await getActivosFijos();
    const activosFilter = activosTempo.filter((e) =>
      [47].includes(e?.IdTipoActivo)
    );
    setActivos(activosFilter);

    const redTempo = await getRedes();
    const filterRed = redTempo.filter((e) => [2].includes(e?.IdTipoRed));
    setRedes(filterRed);

    const tipoDispositivoTempo = await getTipoDispositivos();
    setTipoDispositivos(tipoDispositivoTempo);

    const estadosTempo = await getEstadosCategory("General");
    setEstados(estadosTempo);

    const estadoActivo =
      redVideo?.IdRed > 0
        ? estadosTempo.find((e) => e.IdStatus === redVideo?.IdEstado)
        : estadosTempo.find((e) => e.IdStatus === 5);

    setValues({
      ...redVideo,
      TipoDispositivo: tipoDispositivoTempo.find(
        (t) => redVideo?.IdTipoDispositivo === t?.IdTipoDispositivo
      ),
      Marca: marcasTempo.find((m) => redVideo?.IdMarca === m.IdMarca),
      Area: areasTempo.find((a) => redVideo?.IdArea === a.IdArea),
      Activo: activosTempo.find((a) => redVideo?.IdActivo === a.IdActivo),
      Red: redTempo.find((a) => redVideo?.IdRedNVR === a.IdRed),
      Estado: estadoActivo,
    });

    setLoading(false);
  };
  
  const verificarInfo = () => {
    let error = {};
    if (!values?.TipoDispositivo?.IdTipoDispositivo || !values?.TipoDispositivo) {
      error.IdTipoDispositivo = true;
      error.error = true;
    }
    setError(error);
    return error;
  };

  const verificarDuplicado = () => {
    const duplicado = listRedVideo.find(
      (r) => r.IdRedVideo !== values.IdRedVideo && r.DireccionIP === values?.DireccionIP
    );

    if (duplicado) {
      let mensaje = "Ya existe una IP con el mismo valor de: ";
      if (duplicado.DireccionIP === values.DireccionIP)
        mensaje += `${duplicado.DireccionIP} `;
      return mensaje;
    }

    return null;
  };


  const agregar = async () => {
    const e = verificarInfo();
    if (!e.error) {

      const duplicado = verificarDuplicado();

      if (duplicado) {
        toastShow(toast, "error", "Error", duplicado);
        return;
      }

      const Datos = {
        IdRedVideo: values?.IdRedVideo,
        DireccionIP: values?.DireccionIP,
        Ubicacion: values?.Ubicacion,
        IdTipoDispositivo: values?.TipoDispositivo?.IdTipoDispositivo,
        NVR: values?.NVR,
        Canal: values?.Canal,
        IdMarca: values?.Marca?.IdMarca,
        Modelo: values?.Modelo,
        Serie: values?.Serie,
        IdArea: values?.Area?.IdArea,
        IdActivo: values?.Activo?.IdActivo,
        IdRedNVR: values?.Red?.IdRed,
        Comentario: values?.Comentario,
        IdEstado: values?.IdEstado,
        IdUserCreated: userAuth?.IdUser,
        IdUserEdit: userAuth?.IdUser,
      };

      setLoading(true);
      if (Datos.IdRedVideo > 0) {
        const resultado = await editarRedVideo(Datos);
        if (resultado[0]?.ESTADO === 1) {
          toastShow(toast, "success", "Datos Editados", resultado[0]?.MENSAJE);
          getInfo();
          setTimeout(() => {
            onHide();
            setLoading(false);
          }, 1300);
        } else {
          toastShow(toast, "error", "Error al Editar", resultado[0]?.MENSAJE);
        }
      } else {
        const resultado = await guardarRedVideo(Datos);
        if (resultado[0]?.ESTADO === 1) {
          toastShow(toast, "success", "Datos Agregados", resultado[0]?.MENSAJE);
          getInfo();
          setTimeout(() => {
            onHide();
            setLoading(false);
          }, 1300);
        } else {
          toastShow(toast, "error", "Error al agregar", resultado[0]?.MENSAJE);
        }
      }
    }
  };

  const onHide = () => {
    setShowDialog(false);
    resetForm();
    setError({});
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={redVideo?.IdRedVideo > 0 ? "Editar" : "Guardar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          agregar();
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (showDialog) {
      getValoresIniciales();
    }
  }, [showDialog]);

  const dialogTitle = redVideo?.IdRedVideo > 0 ? "Editar Red" : "Agregar Red";
  return (
    <div>
      <Dialog
        visible={showDialog}
        modal
        className="modal__contenedor1"
        footer={DialogFooter}
        onHide={onHide}
        header={dialogTitle}
        style={{ width: "60%" }}
      >
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ margin: "auto" }}>
            <Toast ref={toast} style={{ zIndex: 50000 }} />

            <div className="modal__input-contenedor gap-2">
              <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="DireccionIP"
                    value={values?.DireccionIP}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.DireccionIP ? "p-invalid" : ""}
                  />
                  <label htmlFor="DireccionIP">IP</label>
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="Ubicacion"
                    value={values?.Ubicacion}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.Ubicacion ? "p-invalid" : ""}
                  />
                  <label htmlFor="Ubicacion">Ubicación</label>
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Area"}
                    value={values?.Area}
                    items={areas}
                    field={"Area"}
                    label={"Area"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdArea ? "p-invalid" : ""}
                  />
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor gap-2">
              <div className="field col-4">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"TipoDispositivo"}
                    value={values?.TipoDispositivo}
                    items={tipoDispositivos}
                    field={"TipoDispositivo"}
                    label={"Tipo Dispositivo"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdTipoDispositivo ? "p-invalid" : ""}
                  />
                </span>
              </div>
              
              <div className="field col-4">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Red"}
                    value={values?.Red}
                    items={redes}
                    field={"NombreRed"}
                    label={"NVR"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdRedNVR ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="Canal"
                    value={values?.Canal}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.Canal ? "p-invalid" : ""}
                  />
                  <label htmlFor="Canal">Canal</label>
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor gap-2">
              <div className="field col-4">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Marca"}
                    value={values?.Marca}
                    items={marcas}
                    field={"Marca"}
                    label={"Marca"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdMarca ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="Modelo"
                    value={values?.Modelo}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.Modelo ? "p-invalid" : ""}
                  />
                  <label htmlFor="mMdelo">Modelo</label>
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="Serie"
                    value={values?.Serie}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.Serie ? "p-invalid" : ""}
                  />
                  <label htmlFor="Serie">Serie</label>
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor gap-2">
              <div className="field col-4">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Activo"}
                    value={values?.Activo}
                    items={activos}
                    field={"NombreActivo"}
                    label={"Activo"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdActivo ? "p-invalid" : ""}
                  />
                </span>
              </div>
              <div className="field col-8">
                <span className="p-float-label">
                  <InputTextarea
                    name="Comentario"
                    value={values?.Comentario}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    rows={1}
                    className={error.Comentario ? "p-invalid" : ""}
                  />
                  <label htmlFor="Comentario">Comentario</label>
                </span>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default RedVideoCRUD;
